import { UserManager, UserManagerSettings } from 'oidc-client-ts';
import generateOIDCOptions from '../generate-oidc-options';

// Singleton UserManager instance
let userManagerInstance: UserManager | null = null;

/**
 * Creates or returns the existing UserManager instance.
 * This ensures a single UserManager is shared across the entire application.
 *
 * @returns {UserManager} The shared UserManager instance
 */
export const getUserManager = (): UserManager => {
	if (!userManagerInstance) {
		const settings = generateOIDCOptions();
		userManagerInstance = new UserManager(settings);
	}

	return userManagerInstance;
};

/**
 * Resets the UserManager instance. Useful for testing or when environment changes.
 *
 * @param newSettings - Optional new settings to use when creating the new instance
 * @returns {UserManager} The new UserManager instance
 */
export const resetUserManager = (newSettings?: UserManagerSettings): UserManager => {
	userManagerInstance = null;

	if (newSettings) {
		userManagerInstance = new UserManager(newSettings);
	} else {
		userManagerInstance = new UserManager(generateOIDCOptions());
	}

	return userManagerInstance;
};

// Default export for convenience
export default getUserManager;
